import {AudioManager} from "admin/audio/audio_manager"; 
window.AudioManager = AudioManager; // This needs to be refactored. 

require('admin/audio/audio_modal')

require("admin/treatments/create_treatment")
require("admin/treatments/call_treatments")
require("admin/text_treatments/text_treatments")

import {SiteHours} from 'admin/locations/site_hours'
window.SiteHours = SiteHours;

import {CampaignDetail} from "admin/campaigns/campaign-detail"
window.CampaignDetail = CampaignDetail;
require("admin/campaigns/edit_multi_modal")
import {EditCampaign} from 'admin/campaigns/edit_campaign'
window.EditCampaign = EditCampaign;

import {NewCampaign} from 'admin/campaigns/new_campaign'
window.NewCampaign = NewCampaign;

require("admin/locations/webhooks/location_webhooks")
require("admin/webhooks/all_webhook_management")
require("admin/audio/all_audio_management")

require("admin/groups/group_management")

require("admin/permission_manager")

require("admin/dni_campaigns/digital_campaign_splash.js")
require("admin/dni_campaigns/dni_campaigns.js")

require("admin/locations/location_settings.js")
require("admin/locations/advanced_settings.js")
require("admin/locations/book_now_settings.js")
require("admin/locations/ga4_settings.js")
require("admin/locations/digital_campaigns/digital_campaigns_chat_settings.js")

import {confirmPlus} from 'admin/common/custom_confirm'
window.confirmPlus = confirmPlus;

import "admin/campaigns/filters_slideout"
require("admin/accounting/rate_schedule_cards")
require("admin/accounting/rate_schedule_card_base")
require("admin/accounting/rate_schedule_cards")
require("admin/accounting/rate_schedule_groups_management")
require("admin/accounting/rate_schedule_groups_management_detail_row")
require("admin/accounting/rate_schedule_group_editor_rate_schedules")
require("admin/accounting/rate_schedule_group_editor")
require("admin/accounting/rate_schedule_group_industries")
require("admin/accounting/rate_schedule_group_rate_schedule_editor")
require("admin/accounting/current_billing_info/current_billing_info_boxes")
require("admin/accounting/current_billing_info/current_bill_amount")
require("admin/accounting/current_billing_info/next_due_date")
require("admin/accounting/current_billing_info/payment_info")
require("admin/accounting/current_billing_info/payment_methods")
require("admin/accounting/current_billing_plan")
require("admin/accounting/auto_group_rate_schedule_cards")

require("admin/treatments/call_treatments_list")

import { TreatmentsManager } from "../admin/treatments/treatments_manager";
window.TreatmentsManager = TreatmentsManager

import 'admin/mass_edit/mass_edit';
